<div class="main-content table-page table-page--compact fise-config-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Configuración de Servidores y Aplicaciones</h1>
        <p>Seleccione un servidor para habilitar las opciones de configuración.</p>
      </div>
    </section>

    <div class="fise-config__grid fise-config__grid--three fise-config__grid--workflow">
      <section class="table-page__card fise-matrix__panel fise-config__panel fise-config__panel--users-cos">
        <div class="fise-matrix__panel-head">
          <div class="fise-config__functional-heading fise-config__functional-heading--users" aria-hidden="true">
            <i class="material-icons">group</i>
            <span>Visualización de usuarios para acceso de servidor</span>
          </div>
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Usuarios COS</h2>
            <p>Seleccione uno o más usuarios COS para configurar sus accesos.</p>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input aria-label="Buscar usuario" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="filtroUsuarioCos"
              (ngModelChange)="onUsuarioCosFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaUsuarios.length > 0; else usuariosCosEmptyState">
            <thead>
              <tr>
                <th class="table-page__actions-head">Seleccionar</th>
                <th>Usuario</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listaUsuarios" class="is-clickable"
                [class.is-selected]="isUsuarioCosSeleccionado(usuarioBean)" (click)="onSelectUsuarioCos(usuarioBean)" (keydown.enter)="$event.target === $event.currentTarget ? onSelectUsuarioCos(usuarioBean) : null">
                <td class="table-page__actions">
                  <mat-checkbox [checked]="isUsuarioCosSeleccionado(usuarioBean)" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null"
                    (change)="onCambioSeleccionUsuarioCos(usuarioBean, $event.checked)"></mat-checkbox>
                </td>
                <td>
                  <strong class="table-page__name">{{ usuarioBean.user_nom }}</strong>
                </td>
                <td>{{ usuarioBean.persona?.nombre || usuarioBean.nombrePersona || 'Sin nombre' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosCosEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsuariosCos; else usuariosCosLoadingState">
              <i class="material-icons">group</i>
              <strong>No se encontraron usuarios</strong>
              <span>Ajuste el filtro para localizar el usuario COS a configurar.</span>
            </div>
          </ng-template>

          <ng-template #usuariosCosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersCosPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersCosRangeEnd }} de {{ totalRegistrosUsuario }} usuarios</span>
            <span>Página {{ usersCosCurrentPage }} de {{ usersCosTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersCosPageSize" (ngModelChange)="onUsersCosPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="usersCosTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersCosPage()"
              [disabled]="usersCosCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersCosPage()"
              [disabled]="usersCosCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getUsersCosPaginationItems()">
              <button *ngIf="isPageNumber(item); else usersCosEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === usersCosCurrentPage" (click)="onUsersCosPageChange(item)">{{ item
                }}</button>
              <ng-template #usersCosEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextUsersCosPage()"
              [disabled]="usersCosCurrentPage === usersCosTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersCosPage()"
              [disabled]="usersCosCurrentPage === usersCosTotalPages">Último</button>
          </div>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel fise-config__panel fise-config__panel--server">
        <div class="fise-matrix__panel-head">
          <div class="fise-config__server-intro">
            <span class="fise-config__step-number" aria-hidden="true">1</span>
            <div class="fise-matrix__panel-copy">
              <span class="fise-matrix__panel-step">Paso 1</span>
              <h2>Seleccionar servidor</h2>
              <p>Elija el servidor en el que se administrarán las aplicaciones y usuarios.</p>
              <mat-form-field appearance="outline" class="table-page__search-field">
                <mat-label>Buscar servidor</mat-label>
                <mat-select [value]="servidorSelect" (selectionChange)="onSelectServidor($event.value)"
                  panelClass="fise-config__server-select-panel">
                  <mat-select-trigger>{{ servidorSelect?.ip || 'Seleccione un servidor' }}</mat-select-trigger>
                  <div class="fise-config__select-search-slot" (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()">
                    <i class="material-icons" aria-hidden="true">search</i>
                    <input type="text" maxlength="15" soloip [(ngModel)]="filtroServidor"
                      (ngModelChange)="onServidorFilterChange()" placeholder="Buscar por dirección IP"
                      aria-label="Buscar servidor por dirección IP" />
                  </div>
                  <mat-option *ngFor="let servidorBean of listaServidores" [value]="servidorBean">
                    <span class="fise-config__server-option">
                      <strong>{{ servidorBean.ip }}</strong>
                      <small>{{ servidorBean.so || 'Sin definir' }}</small>
                    </span>
                  </mat-option>
                  <mat-option *ngIf="loadingServidores" disabled>Cargando servidores...</mat-option>
                  <mat-option *ngIf="!loadingServidores && listaServidores.length === 0" disabled>No se encontraron
                    servidores</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="fise-config__server-summary" *ngIf="servidorSelect?.id_Servidor; else serverSummaryHint">
            <div>
              <span>IP</span>
              <strong>{{ servidorSelect.ip }}</strong>
            </div>
            <div>
              <span>Sistema operativo</span>
              <strong>{{ servidorSelect.so || 'Sin definir' }}</strong>
            </div>
            <div>
              <span>Tipo</span>
              <strong>{{ servidorSelect.tipoServidor || 'Sin definir' }}</strong>
            </div>
            <div>
              <span>Ubicación</span>
              <strong>{{ servidorSelect.ubicacion || 'Sin definir' }}</strong>
            </div>
          </div>
          <ng-template #serverSummaryHint>
            <div class="fise-config__server-summary fise-config__server-summary--empty">
              <i class="material-icons">dns</i>
              <span>Seleccione un servidor para consultar su información.</span>
            </div>
          </ng-template>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel fise-config__panel fise-config__panel--applications">
        <div class="fise-matrix__panel-head">
          <div class="fise-config__functional-heading fise-config__functional-heading--applications" aria-hidden="true">
            <i class="material-icons">apps</i>
            <span>Visualización de usuarios para acceso a las aplicaciones</span>
          </div>
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Aplicaciones</h2>
            <p *ngIf="servidorSelect.id_Servidor; else appsHint">Servidor seleccionado: {{ servidorSelect.ip }}</p>
            <ng-template #appsHint>
              <p>Seleccione un servidor para ver las aplicaciones configurables.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar aplicación</mat-label>
            <input aria-label="Buscar aplicación" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="filtroAplicacion"
              (ngModelChange)="onAplicacionFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaAplicaciones.length > 0; else aplicacionesEmptyState">
            <thead>
              <tr>
                <th>Aplicación</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let aplicacionBean of listaAplicaciones" class="is-clickable"
                [class.is-selected]="aplicacionSelect.id === aplicacionBean.id"
                (click)="onSelectAplicacion(aplicacionBean)" (keydown.enter)="onSelectAplicacion(aplicacionBean)">
                <td>
                  <strong class="table-page__name">{{ aplicacionBean.idTipo }}</strong>
                </td>
                <td>{{ aplicacionBean.descripcion || 'Sin descripción' }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #aplicacionesEmptyState>
            <div class="table-page__empty" *ngIf="!loadingAplicaciones; else aplicacionesLoadingState">
              <i class="material-icons">apps</i>
              <strong>{{ getAplicacionesEmptyTitle() }}</strong>
              <span>{{ getAplicacionesEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #aplicacionesLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando aplicaciones...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showAppsPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ appsRangeEnd }} de {{ totalRegistrosAplicacion }} aplicaciones</span>
            <span>Página {{ appsCurrentPage }} de {{ appsTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="appsPageSize" (ngModelChange)="onAppsPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="appsTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstAppsPage()"
              [disabled]="appsCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousAppsPage()"
              [disabled]="appsCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getAppsPaginationItems()">
              <button *ngIf="isPageNumber(item); else appsEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === appsCurrentPage" (click)="onAppsPageChange(item)">{{ item }}</button>
              <ng-template #appsEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextAppsPage()"
              [disabled]="appsCurrentPage === appsTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastAppsPage()"
              [disabled]="appsCurrentPage === appsTotalPages">Último</button>
          </div>
        </div>
      </section>
    </div>

    <div class="fise-config__grid fise-config__grid--two fise-config__grid--optional">
      <section class="table-page__card fise-matrix__panel fise-config__panel fise-config__panel--server-users">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Usuarios de Servidor</h2>
            <p *ngIf="servidorSelect.id_Servidor; else usuariosServidorHint">{{ usuariosCosSeleccionadosCantidad }}
              usuarios COS seleccionados · Servidor: {{ servidorSelect.ip }}</p>
            <ng-template #usuariosServidorHint>
              <p>Seleccione un servidor para habilitar esta configuración.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input aria-label="Buscar usuario" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="filtroUsuarioServidor"
              (ngModelChange)="onUsuarioServidorFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaUsuariosServidor.length > 0; else usuariosServidorEmptyState">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Tipo</th>
                <th class="table-page__actions-head">Seleccionar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listaUsuariosServidor" class="is-clickable"
                [class.is-selected]="usuarioBean.check" [class.is-mixed]="isUsuarioServidorConEstadoMixto(usuarioBean)"
                (click)="onClicBoxServer(usuarioBean, !usuarioBean.check)" (keydown.enter)="$event.target === $event.currentTarget ? onClicBoxServer(usuarioBean, !usuarioBean.check) : null">
                <td>
                  <strong class="table-page__name">{{ usuarioBean.usuario }}</strong>
                </td>
                <td>{{ usuarioBean.tipo_usuario || 'Sin definir' }}</td>
                <td class="table-page__actions">
                  <mat-checkbox [checked]="usuarioBean.check" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null"
                    (change)="onClicBoxServer(usuarioBean, $event.checked)"></mat-checkbox>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosServidorEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsuariosServidor; else usuariosServidorLoadingState">
              <i class="material-icons">group</i>
              <strong>{{ getUsuariosServidorEmptyTitle() }}</strong>
              <span>{{ getUsuariosServidorEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #usuariosServidorLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios de servidor...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersServerPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersServerRangeEnd }} de {{ totalRegistrosUsuarioServidor }} usuarios</span>
            <span>Página {{ usersServerCurrentPage }} de {{ usersServerTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersServerPageSize" (ngModelChange)="onUsersServerPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="usersServerTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersServerPage()"
              [disabled]="usersServerCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersServerPage()"
              [disabled]="usersServerCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getUsersServerPaginationItems()">
              <button *ngIf="isPageNumber(item); else usersServerEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === usersServerCurrentPage" (click)="onUsersServerPageChange(item)">{{ item
                }}</button>
              <ng-template #usersServerEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextUsersServerPage()"
              [disabled]="usersServerCurrentPage === usersServerTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersServerPage()"
              [disabled]="usersServerCurrentPage === usersServerTotalPages">Último</button>
          </div>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel fise-config__panel fise-config__panel--application-users">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <h2 class="fise-matrix__panel-step">Usuarios de Aplicación</h2>
            <p *ngIf="aplicacionSelect.id; else usuariosAppHint">Aplicación seleccionada: {{ aplicacionSelect.idTipo }}
            </p>
            <ng-template #usuariosAppHint>
              <p>Seleccione una aplicación para finalizar la configuración.</p>
            </ng-template>
          </div>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input aria-label="Buscar usuario" matInput maxlength="80" soloLetraEspacioNumeroAcento [(ngModel)]="filtroUsuarioApp"
              (ngModelChange)="onUsuarioAppFilterChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaUsuariosApp.length > 0; else usuariosAppEmptyState">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Tipo</th>
                <th class="table-page__actions-head">Seleccionar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listaUsuariosApp">
                <td>
                  <strong class="table-page__name">{{ usuarioBean.usuario }}</strong>
                </td>
                <td>{{ usuarioBean.tipo_usuario || 'Sin definir' }}</td>
                <td class="table-page__actions">
                  <mat-checkbox [(ngModel)]="usuarioBean.check"
                    (change)="onClicBoxUsuarioAplicacion(usuarioBean, $event.checked)"></mat-checkbox>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosAppEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsuariosApp; else usuariosAppLoadingState">
              <i class="material-icons">group</i>
              <strong>{{ getUsuariosAppEmptyTitle() }}</strong>
              <span>{{ getUsuariosAppEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #usuariosAppLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios de aplicación...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersAppPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersAppRangeEnd }} de {{ totalRegistrosUsuarioApp }} usuarios</span>
            <span>Página {{ usersAppCurrentPage }} de {{ usersAppTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersAppPageSize" (ngModelChange)="onUsersAppPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>
          <div class="table-page__pager" *ngIf="usersAppTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersAppPage()"
              [disabled]="usersAppCurrentPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersAppPage()"
              [disabled]="usersAppCurrentPage === 1">Anterior</button>
            <ng-container *ngFor="let item of getUsersAppPaginationItems()">
              <button *ngIf="isPageNumber(item); else usersAppEllipsis" type="button" class="table-page__pager-page"
                [class.is-current]="item === usersAppCurrentPage" (click)="onUsersAppPageChange(item)">{{ item
                }}</button>
              <ng-template #usersAppEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
            </ng-container>
            <button type="button" class="table-page__pager-link" (click)="nextUsersAppPage()"
              [disabled]="usersAppCurrentPage === usersAppTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersAppPage()"
              [disabled]="usersAppCurrentPage === usersAppTotalPages">Último</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>